import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';


const initialValues = {
};

const validationSchema = Yup.object({
/*     title: Yup.string()
    .required(' '),
    activeId: Yup.number()
    .required('این فیلد الزامی است..'),
    businessId: Yup.number()
    .required('این فیلد الزامی است..'), */
});

const activeCase = [
    {
        id: 0,
        title: "غیر فعال"
    }, {
        id: 1,
        title: "فعال"
    }
];

const Create = () => {

    const [activeList, setActiveList] = useState([]);
    const [businessList, setBusinessList] = useState([]);
    const { isEditMode, setIsEditMode } = (true)

    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')
    const { addData: addDataGroup } = useEntityCrud('Group/SetGroup')
    
    const navigate = useNavigate();


    useEffect(() => {
        readDataBusiness().then(res => {
            setBusinessList(res.data.result.map(item => ({ value: item.id, label: item.title, isActive: item.isActive })))
        });
        setActiveList(activeCase.map(item => ({ value: item.id, label: item.title })))
    }, [])


    const onSubmit = (values) => {
        const postedData = {
            title: values.title,
            isActive:  true,
            businessId: values.businessId.value
        };
        addDataGroup(postedData).then(res => {
            if (res.status === 200) {
                if (res.data.status === false) {
                    res.data.errors.map(error => toast.error(error.message));
                }
                else {
                    navigate("/group");
                    toast.success('گروه با موفقیت در سیستم ثبت شد.');
                }
            } else
                res.data.errors.map(error => toast.error(error.message));
                
        })
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSubmit,
        validationSchema: validationSchema
    });



 
    const handleBack = () => {
        navigate('/group', {replace: true});
    }


    return (
        <div className="card">
            <div className="card-header  d-flex justify-content-between">
                <div className="card-title">
                    <div>
                     {/*    <i className='fa fa-plus px-1'></i> */}
                        ایجاد گروه جدید
                    </div>
                </div>
                <a className='backIconLink' onClick={handleBack}> <i className='fa fa-arrow-left'
                    title="بازگشت"> </i> </a>
            </div>
            <div className="card-body">
                <Form formik={formik} activeList={activeList} businessList={businessList}  isEditMode={false}/>
            </div>
        </div>
    );
}

export default Create;